import { AsgardDocBase } from 'src/app/core/documents/asgard-doc-base';
import { ICommand } from './commands.interface';

export class AsgardCommandBase implements ICommand {
    // private previousValue: any;

    constructor(
        public doc: AsgardDocBase,
        // private propertyName: string,
        // private value: any
    ) {
    }

    async execute(): Promise<any> {
        console.log('execute: ', this.doc);
        // this.previousValue = this.receiver[this.propertyName];
        // this.receiver[this.propertyName] = this.value;
    }

    async undo(): Promise<any> {
        console.log('undo: ', this.doc);
        // this.receiver[this.propertyName] = this.previousValue;
    }
}
